'use strict';

const DrawingElement = require('../classes/DrawingElement');
const Shape = require('../classes/Shape');
const Point = require('../classes/Point');
const ShapeTable = require('../classes/ShapeTable');

module.exports = new DrawingElement('polygons', function () {

    const select = this.addShapeSelector(3, 20);
    const addButton = this.addButton('add');
    const resetButton = this.addButton('reset');

    const tablePadding = this.pad / 2;

    let polygons = [];

    const table = new ShapeTable(1, 1);
    table.setPadding(tablePadding);
    table.setAnchorPoint(new Point(this.pad, this.pad));

    const maxShapes = Math.pow(10, 2);
    const addShape = (numSides, draw) => {
        if (polygons.length >= maxShapes) {
            polygons = [];
            table.setShapes(polygons);
            table.setNumColumns(1);
            table.setNumRows(1);
        }

        let shape = new Shape(numSides, Point.origin(), 100);
        polygons.push(shape);

        table.setShapes(polygons);

        if (draw) {
            const numColumns = Math.ceil(Math.sqrt(polygons.length));
            const desiredShapeWidth = (this.width - (this.pad * 2) - (tablePadding * (numColumns - 1))) / numColumns;

            polygons.forEach((shape) => {
                shape.scaleToFitWithin(desiredShapeWidth);
            });
            table.distributeShapes();

            this.wipe();
            table.draw(this.ctx);
        }
    };

    for (let i = 5; i < 8; i++) {
        addShape(i);
    }
    addShape(8, true);

    addButton.addEventListener('click', () => {
        addShape(parseInt(select.value, 10), true);
    });
    resetButton.addEventListener('click', () => {
        this.wipe();
        polygons = [];
        table.setShapes(polygons);
        table.setNumRows(1);
        table.setNumColumns(1);
    });
});


